import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import FolderView from '@/components/FolderTree/FolderTree.vue'
export default {
  props: {
    is_public: {
      type: Boolean,
      default: false,
    },
    portal_admin: {
      type: Boolean,
      default: false,
    },
    current_portal_permissions: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {

    return ({
      user_details: {
        "user_role": '',
        "user_id": null,
      },
      selectedDocumentIds: [],
      selectedFolderId: '',
      previewDocumentUrl: '',
      folders: [],
      folderStack: [], // keeps track of navigation history
      currentFolders: [],
      currentFiles: [],
      isLoading: false,
      is_uploading: false,
      isCreatingFolder: false,
      is_editing_folder: false,
      current_editing_folder: null,
      folder_name: "",
      validation_error: "",
    })
  },
  components: {
    FolderView
  },
  computed: {
    can_create() {
      return this.current_portal_permissions?.create === true || this.portal_admin === true;
    },
    can_edit() {
      return this.current_portal_permissions?.edit === true || this.portal_admin === true;
    },
    can_upload() {
      return this.current_portal_permissions?.upload === true || this.portal_admin === true;
    },
    can_download() {
      return this.current_portal_permissions?.download === true || this.portal_admin === true;
    },
    can_delete() {
      return this.current_portal_permissions?.delete === true || this.portal_admin === true;
    },
  },
  mounted() {
    this.user_details = get_user_details();
    this.user_id = this.get_user_id();
    this.fetch_document_warehouse_folders();
  },
  watch: {
    '$route.params.portal_id'() {
      this.fetch_document_warehouse_folders();
    }
  },


  methods: {
    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selectedDocumentIds = this.currentFiles.map(file => file.id);
      } else {
        this.selectedDocumentIds = [];
      }
    },

    openMoveToFolderModal() {
      this.fetch_document_warehouse_folders();
      $('#move_to_folder_modal').modal('show');
    },

    moveSelectedDocumentsToFolder() {
      if (!this.selectedFolderId || this.selectedDocumentIds.length === 0) return;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/batch_move_folder_documents/`,
        method: "POST",
        data: JSON.stringify({
          destination_folder_id: this.selectedFolderId,
          folder_document_ids: this.selectedDocumentIds
        }),
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            this.currentFiles = this.currentFiles.filter(file => !this.selectedDocumentIds.includes(file.id));
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Documents moved to folder successfully.',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#move_to_folder_modal').modal('hide');
              this.selectedFolderId = null;
              this.selectedDocumentIds = [];
            })
          }
        },
        error: (xhr) => {
          console.error("Error moving documents to folder:", xhr);
        }

      })
    },
    getToken() {
      return get_token();
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    fetch_document_warehouse_folders() {
      this.isLoading = true;
      const payload = {
        portal_id: this.$route.params.portal_id,
      }
      const params = new URLSearchParams(payload).toString();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_information/?${params}`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.folders = response.data;
          this.currentFolders = this.folders;
        },
        error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handleOpenFolder(folder) {
      this.isLoading = true;
      if (folder.subfolders && folder.subfolders.length > 0) {
        // If the folder has subfolders, push it to the folder stack and update currentFolders
        this.folderStack.push({ id: folder.id, folder_name: folder.folder_name, subfolders: folder.subfolders });
        this.currentFolders = folder.subfolders;
        this.currentFiles = folder.files || [];
      } else if ((!folder.subfolders || folder.subfolders.length === 0) && folder.files && folder.files.length > 0) {
        // If the folder has files but no subfolders, still allow navigation
        this.folderStack.push({ id: folder.id, folder_name: folder.folder_name, subfolders: [] });
        this.currentFolders = [];
        this.currentFiles = folder.files;
        this.isLoading = false;
      } else {
        // If the folder is empty, update the state and show the "Folder empty" message
        this.folderStack.push({ id: folder.id, folder_name: folder.folder_name, subfolders: [] });
        this.currentFolders = [];
        this.currentFiles = [];
        this.isLoading = false;
      }

      this.isLoading = false;
    },

    goBack() {
      if (this.folderStack.length > 0) {
        // Remove the last folder from the stack
        this.folderStack.pop();

        if (this.folderStack.length > 0) {
          // If there are still folders in the stack, update currentFolders and currentFiles
          const parentFolder = this.folderStack[this.folderStack.length - 1];
          this.currentFolders = parentFolder.subfolders || [];
          this.currentFiles = parentFolder.files || [];
        } else {
          // If no folders are in the stack, reset to the root level
          this.currentFolders = this.folders || [];
          this.currentFiles = []; // Clear files at the root level
        }
      }
    },

    getFileIcon(fileUrl) {
      if (fileUrl.includes('.pdf')) return 'https://cdn-icons-png.flaticon.com/128/337/337946.png';
      if (fileUrl.includes('.doc') || fileUrl.includes('.docx')) return 'https://cdn-icons-png.flaticon.com/128/337/337932.png';  // Word icon
      if (fileUrl.includes('.xls') || fileUrl.includes('.xlsx')) return 'https://cdn-icons-png.flaticon.com/128/337/337958.png';  // Excel icon
      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png';
    },

    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },

    previewDocument(fileObj) {
      if (fileObj && fileObj.file && fileObj.file.s3_url) {
        const fileUrl = fileObj.file.s3_url;
        const fileType = this.getFileType(fileUrl);

        if (fileType === 'word' || fileType === 'excel') {
          this.previewDocumentUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileUrl);
        } else {
          this.previewDocumentUrl = fileUrl;
        }
        this.previewDocumentType = fileType;
        $("#document_preview_modal").modal("show");
      } else {
        console.error("File object or file URL is missing");
      }
    },

    getFileType(url) {
      if (typeof url !== 'string') return 'unknown';

      try {
        const parsedUrl = new URL(url);
        const pathname = parsedUrl.pathname; // Gets the part after the domain
        const filename = pathname.split('/').pop(); // Gets "Workstreams -Sprint 13 (3).docx"
        const extension = filename.split('.').pop().toLowerCase();

        if (extension === 'pdf') return 'pdf';
        if (['doc', 'docx'].includes(extension)) return 'word';
        if (['xls', 'xlsx'].includes(extension)) return 'excel';
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) return 'image';

        return 'unknown';
      } catch (error) {
        console.error("Invalid URL in getFileType:", error);
        return 'unknown';
      }
    },
    open_create_folder_modal() {
      this.is_editing_folder = false;
      this.current_editing_folder = null;
      this.folder_name = "";
      this.validation_error = "";
      $("#staticBackdrop").modal("show");
    },

    open_edit_folder_modal(folder) {
      this.is_editing_folder = true;
      this.current_editing_folder = folder;
      this.folder_name = folder.folder_name;
      this.validation_error = "";
      $("#staticBackdrop").modal("show");
    },
    
    update_folder() {
      if (!this.current_editing_folder) return;
      
      this.validation_error = "";
      if (!this.folder_name || this.folder_name.trim() === '') {
        this.validation_error = "Folder name cannot be empty.";
        return;
      }

      const payload = {
        folder_id: this.current_editing_folder.id,
        folder_name: this.folder_name
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_folder_api/`,
        method: 'POST',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === 'success') {
            const current_editing_folder = response.folder_data;
            const index = this.currentFolders.findIndex(f => f.id === this.current_editing_folder.id);
            if (index !== -1) {
              this.currentFolders.splice(index, 1, current_editing_folder);
            }
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: response.message,
              showConfirmButton: false,
              timer: 1500,
              position: 'bottom-end',
              toast: true
            });
          }
        },
        error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          $("#staticBackdrop").modal("hide");
        }
      });
    },

    create_folder() {
      this.validation_error = "";
      if (!this.folder_name || this.folder_name.trim() === '') {
        this.validation_error = "Folder name cannot be empty.";
        return;
      }

      this.isCreatingFolder = true;
      const parentFolderId = this.folderStack.length > 0 ? this.folderStack[this.folderStack.length - 1].id : null;

      // Prepare the payload for the new folder
      const payload = {
        folder_name: this.folder_name,
        is_parent: true,
        portal_id: this.$route.params.portal_id,
      };

      if (parentFolderId !== null) {
        payload.parent_folder_id = parentFolderId;
        payload.is_parent = false
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_folder_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Folder created successfully.',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              Swal.close();
              const newFolder = {
                id: data.folder_data.id, // Assuming the API returns the new folder's ID
                folder_name: this.folder_name,
                date_created: data.folder_data.date_created,
                subfolders: [],
                files: [],
              };
              this.currentFolders.push(newFolder);

              // Clear the folder name input
              this.folder_name = '';


            });
          }
        },
        error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.isLoading = false;
          this.isCreatingFolder = false; // Stop loader
          $("#staticBackdrop").modal("hide");
        }
      });
    },

    delete_folder_document(folder_document_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder_document/`,
            method: 'DELETE',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({
              folder_document_id: folder_document_id
            }),
            success: (data) => {
              if (data.status === "success") {
                this.currentFiles = this.currentFiles.filter(file => file.id !== folder_document_id);
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Document deleted successfully.',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  Swal.close();

                });
              }
            },
            error: (xhr) => {
              let errorMessage = 'An unexpected error occurred.';
              if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMessage = xhr.responseJSON.message;
              }
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              });
            },
            complete: () => {
              this.isLoading = false;
            }
          });
        }
      });
    },

    triggerFileUpload() {
      this.$refs.warehouse_file.click();
    },

    handleFileUpload(event) {
      // Check if user has upload permission (includes admin check in can_upload computed property)
      if (!this.can_upload) {
        Swal.fire({
          icon: 'error',
          title: 'Access Denied',
          text: 'You do not have permission to upload documents.',
          showConfirmButton: true
        });
        if (this.$refs.warehouse_file) {
          this.$refs.warehouse_file.value = '';
        }
        return;
      }

      const file = event.target.files[0];
      if (file) {
        this.is_uploading = true;
        const fileName = file.name; // Extract the document name
        const formData = new FormData();
        formData.append('file', file);
        formData.append('portal_id', this.$route.params.portal_id);
        formData.append('file_name', fileName);

        // If inside a folder, pass the parent folder ID
        const parentFolderId = this.folderStack.length > 0 ? this.folderStack[this.folderStack.length - 1].id : null;
        if (parentFolderId) {
          formData.append('folder_id', parentFolderId);
        }

        // Make an API call to upload the document
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_folder_document_api/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          data: formData,
          processData: false,
          contentType: false,
          success: (data) => {
            if (data.status === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Document uploaded successfully.',
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                Swal.close();

                const newFile = {
                  id: data.document_folder_data.id,
                  file: {
                    name: fileName,
                    s3_url: data.document_folder_data.file.s3_url,
                    date: data.document_folder_data.file.date,
                  }
                };
                this.currentFiles.push(newFile);

              });
            }
          },
          error: (xhr) => {
            let errorMessage = 'An unexpected error occurred.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
          },
          complete: () => {
            this.is_uploading = false;
            if (this.$refs.warehouse_file) {
              this.$refs.warehouse_file.value = '';
            }
          },
        });
      }
    },

    remove_folder(folderId) {
      this.currentFolders = this.currentFolders.filter(f => f.id !== folderId);
    },

          // ✅ Ensure consistent structure
  }
};
